import { Component } from 'preact'
import { getIdAndContentTypeFromTopics, UnifiedTopic } from '../../utils'
import MarkAsSpamModal from './MarkAsSpamModal'
/* eslint-disable import/no-internal-modules */
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import Icon from '@insided/deprecated-preact-components/assets'
import { markPostsAsSpam } from '@insided/shared/services/spamService'
import Button from '@insided/control/uikit/Button'

interface State {
  isModalOpen: boolean
}

class MarkAsSpam extends Component<BulkActionComponentProps, State> {
  state = {
    isModalOpen: false
  }

  render() {
    const { numberOfSelectedItems, performBulkAction, type } = this.props
    const { isModalOpen } = this.state
    const entity = type === 'ideation' ? 'idea' : 'topic'
    const successMessage = numberOfSelectedItems > 1 ? `You've marked ${numberOfSelectedItems} ${entity}s as spam` : `You've marked the ${entity} as spam.`
    return (
      <div>
        <Button
          title={
            <div>
              <Icon icon='warning' width={16} height={16} />
              Mark as spam
            </div>
          }
          size='medium'
          variant='warning'
          className='qa-mark-as-spam'
          onClick={() => this.setState({ isModalOpen: true })}
        />
        <MarkAsSpamModal
          numberOfSelectedItems={numberOfSelectedItems}
          isOpen={isModalOpen}
          onMarkAsSpam={() =>
            performBulkAction({
              onClick: async (topics: UnifiedTopic[]) => {
                return await markPostsAsSpam(getIdAndContentTypeFromTopics(topics))
              },
              successMessage: successMessage
            })}
          onClose={() => this.setState({ isModalOpen: false })}
          entity={entity}
        />
      </div>
    )
  }
}

export default MarkAsSpam
